import React, { ChangeEvent } from 'react'
import { ConsentText } from '@mobi/account/Areas/SignUp/Components/Message/ConsentText'
import { Checkbox } from '@mobi/component-library/Selection&Input/Inputs'
import { useSelector } from 'react-redux'
import { getSignUpState } from '../../Store'

type Props = { isBusy: boolean; onChange: (e: ChangeEvent<HTMLInputElement>) => void }
export const DocumentPermission = ({ isBusy, onChange }: Props) => {
  const state = useSelector(getSignUpState)
  return (
    <Checkbox
      name='ConsentText'
      label={<ConsentText isAmlRiskAssessed={state.isNewSignupFlowEnabled} />}
      isDisabled={isBusy}
      onChange={e => onChange(e)}
    />
  )
}
